import { useEffect, useState } from "react";

const INITIAL_RECT = new DOMRectReadOnly(0, 0, 0, 0);

export const useMeasure = <T extends Element = Element>(): [(node: T | null) => void, DOMRectReadOnly] => {
	const [rect, setRect] = useState<DOMRectReadOnly>(INITIAL_RECT);
	const [node, setNode] = useState<T | null>(null);

	useEffect(() => {
		if (!node) {
			return;
		}

		const observer = new ResizeObserver((entries) => {
			if (entries[0]) {
				setRect(entries[0].contentRect);
			}
		});

		observer.observe(node);

		return () => {
			observer.disconnect();
		};
	}, [node]);

	return [setNode, rect];
};
